import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e6f8a71e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6f8a71e')) {
      api.createRecord('e6f8a71e', component.options)
    } else {
      api.reload('e6f8a71e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e6f8a71e", function () {
      api.rerender('e6f8a71e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/investment/index.vue"
export default component.exports